import Container from "components/container";
import React from "react";
import Text from "components/text";
import contactIcon from "assets/images/contact-icon.svg";
import facebookIcon from "assets/images/facebook-icon.svg";
import footerLogo from "assets/images/footer-logo.svg";
import instaIcon from "assets/images/insta-icon.svg";
import instagram from "assets/images/instagram.svg";
import logo from "assets/images/Koncurent-02.png";
import pinIcon from "assets/images/pin-icon.svg";
import styles from "./footer.module.css";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const footerText = `Successful businesses rely on information interchange and exchange, no matter what field is your business or the size of your organization.`;

  const location = useLocation();
  if (!["/contact-us", "/about-us", "/home", "/"].includes(location.pathname)) {
    return null;
  }
  return (
    <div className={`${styles.footerContainer} py-5`}>
      <Container>
        <div className="row">
          <div className="col-md-5 mt-2">
            <img src={logo} alt="footer-logo" style={{width:170,height:30}}/>
            {/* <Text className={`${styles.footerText} mt-4`} dontWrap={false}>
              {footerText}
            </Text> */}
          </div>

          <div className="col-md-4 offset-md-2 mt-2">
            <div className="d-flex">
              <img src={contactIcon} alt="flying-envelope" />
              <Text className={`${styles.footerHeader} mx-1`} dontWrap={false}>
                Contact us if you have any questions:
              </Text>
            </div>
            <Text className={`${styles.footerText} mt-1`} dontWrap={false}>
              Mail: sales@koncurent.com
            </Text>

            {/* <div className="d-flex mt-3">
              <img src={pinIcon} alt="pin-icon" />
              <Text className={`${styles.footerHeader} mx-1`} dontWrap={false}>
                Head Office
              </Text>
            </div>
            <Text className={`${styles.footerText} mt-1`} dontWrap={false}>
              1710 Briargate Blvd, Colorado Springs, CO 80920, United States
            </Text> */}
            <div className="d-flex mt-3 gap-4">
              <a
                href="https://www.linkedin.com/company/koncurent"
                target="_blank"
              >
                <img src={instaIcon} alt="linkedIn" />
              </a>
              <a
                href="https://www.instagram.com/koncurenttech/?igshid=MzRlODBiNWFlZA"
                target="_blank"
              >
                <img src={instagram} alt="instagram" />
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <Text className={`${styles.copyRight}`} dontWrap={false}>
            © {new Date().getFullYear()}. All rights reserved Koncurent
          </Text>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
